import * as React from "react";

interface PropsType {
  message: string;
}

export default function EmptyResults({ message }: PropsType): JSX.Element {
  return (
    <div className="tfs--empty-results">
      <i className="fas fa-sun" />
      <p>{message}</p>

      <div className="clouds">
        <i className="fas fa-cloud" />
        <i className="fas fa-cloud" />
        <i className="fas fa-cloud" />
      </div>
    </div>
  );
}
